import { render, staticRenderFns } from "./HelpMenuContents.vue?vue&type=template&id=5dd36d1f"
import script from "./HelpMenuContents.vue?vue&type=script&lang=js"
export * from "./HelpMenuContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports